/**
 * Need to keep these names outside the component
 * for component type checking in SelectList
 * to avoid circular dependency issue Dropdown -> SelectList -> Dropdown
 */
const DropdownDisplayName = 'Dropdown';
const DropdownItemDisplayName = 'DropdownItem';
const DropdownItemGroupDisplayName = 'DropdownItemGroup';

export { DropdownItemDisplayName as D, DropdownDisplayName as a, DropdownItemGroupDisplayName as b };
//# sourceMappingURL=displayNames-CI4WGOeZ.js.map
